module.exports = __webpack_public_path__ + "static/media/carrer.be5984b4.png";